module.exports = __webpack_public_path__ + "img/attention.cb3d57eb.png";